import React from 'react'
import { ComboBoxGetOptionProperty, ComboBoxOption } from './helper/utils'

type ComboBoxContextType<T extends ComboBoxOption> = {
  classes: any
  filteredOptions: any
  getChipLabel: ComboBoxGetOptionProperty<T>
  getItemProps: (options: any) => any
  getOptionDisabled: ComboBoxGetOptionProperty<T>
  getOptionLabel: ComboBoxGetOptionProperty<T>
  getOptionValue: ComboBoxGetOptionProperty<T>
  hideClearOnDisabled: boolean
  isOptionSelected: <T>(selectedItems: T[], option: T, getOptionLabel: ComboBoxGetOptionProperty<T>) => boolean
  limitChips: number
  multiple: boolean
  options: T[]
  removeSelectedItem: (item: T) => void
  selectedItems: T[]
  setSelectedItems: (items: T[]) => void
}

const ComboBoxContext = React.createContext<ComboBoxContextType<any>>({} as any)

export default ComboBoxContext
